import { BusinessUnit } from 'src/types/orbit/BusinessUnit';

/**
 * Gets the business unit name from a list by ID
 */
export function getBusinessUnitName(
  businessUnitList: BusinessUnit[],
  businessUnitId: string,
): string {
  const bu = businessUnitList.find((bu) => bu.businessUnitId === businessUnitId);
  return bu?.name || businessUnitId;
}

/**
 * Gets the required business unit ID from URL parameters
 */
export function getRequiredBusinessUnitId(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get('bu');
}

/**
 * Handles navigation to preferences page for business unit switching
 * Passes required BU and return URL via URL parameters
 */
export function navigateToBusinessUnitPreferences(
  navigate: (path: string, options?: { state?: any }) => void,
  requiredBusinessUnitId: string,
): void {
  const returnUrl = window.location.pathname + window.location.search;

  // Navigate to preferences with required BU in URL
  navigate(
    `/preferences?switchTo=${requiredBusinessUnitId}&returnUrl=${encodeURIComponent(returnUrl)}`,
  );
}
